import { render, staticRenderFns } from "./xxtd.vue?vue&type=template&id=22675f6e&scoped=true&"
var script = {}
import style0 from "./xxtd.vue?vue&type=style&index=0&id=22675f6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22675f6e",
  null
  
)

export default component.exports